import React from 'react'
import { css, cx } from '@emotion/css'
import { useIntl } from 'react-intl'
import { Link, Text } from '@contrast-security-inc/design-system-typography'

const titleCss = css`
  margin: 0;
`
export const DocLink = (msg) => (
  <Link
    href="https://docs.contrastsecurity.com/en/how-contrast-works.html"
    isExternal
  >
    {msg}
  </Link>
)

export function Header() {
  const { formatMessage } = useIntl()

  return (
    <div
      className={cx(
        css`
          padding: 24px 41px 25px;
          > div:nth-child(1) {
            display: flex;
            flex-direction: column;
            gap: 8px;
            padding-bottom: 8px;
          }
        `
      )}
    >
      <Text font="titleH1" as="h1" className={titleCss}>
        {formatMessage({ id: 'title_addSensorWizard_headerTitle' })}
      </Text>
      <Text font="body" color="neutral60">
        {formatMessage(
          { id: 'title_addSensorWizard_headerDescription' },
          {
            a: DocLink
          }
        )}
      </Text>
    </div>
  )
}
